module.exports = __webpack_public_path__ + "img/shrimps-1.c2095a6d.jpg";